import { createSlice } from '@reduxjs/toolkit';

import { STATUS_TYPES } from '../../constants';
import initialState from './initialState';

const loadDetailsSlice = createSlice({
  name: 'loadDetails',
  initialState,
  reducers: {
    loadDetailsFetching(state) {
      state.status = STATUS_TYPES.INIT_STATE;
    },
    loadDetailsSucceeded(state, { payload }) {
      state.status = STATUS_TYPES.SUCCEED_STATE;
      state.data = payload;
    },
    loadDetailsFailed(state, { payload }) {
      state.status = STATUS_TYPES.FAILED_STATE;
      state.error = {
        status: payload?.status,
        message: payload?.message,
      };
    },
    updateLoadDetails(state, { payload }) {
      state.data = {
        ...state.data,
        ...payload,
      };
    },
    clearLoadDetails() {
      return initialState;
    },
  },
});

export const {
  loadDetailsFailed,
  loadDetailsFetching,
  loadDetailsSucceeded,
  updateLoadDetails,
  clearLoadDetails,
} = loadDetailsSlice.actions;

export default loadDetailsSlice.reducer;
